module.exports = __webpack_public_path__ + "img/shake.be5030ca.webp";